import React, { Component } from "react";

export class IncredModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.ApplicationModal = this;
  }

  render() {
    let { props } = this;
    let {
      id,
      title,
      show,
      onClose,
      modalSize,
      logsData,
      logsColumns,
      errorMessage,
      loader,
      viewmode,
    } = props;
    let attrs = Object.except(props, ["title", "type", "onClose"]);

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
      >
        <AppFormData
          {...attrs}
          onClose={onClose}
          errorMessage={errorMessage}
          viewmode={viewmode}
        ></AppFormData>
      </AppCanvas>
    );
  }
}

export default IncredModal;
